// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3dTJQ","footer":"ModalCreateQualiphyProcedure_footer__2IE6S","additionData":"ModalCreateQualiphyProcedure_additionData__20-H1"};